import { create } from 'zustand';

interface ExperimentalState {
  isExperimental: boolean;
  toggleExperimental: () => void;
}

export const useExperimentalStore = create<ExperimentalState>()((set) => ({
  isExperimental: localStorage.getItem('experimental-ux') === 'on',
  toggleExperimental: () =>
    set((state) => {
      const next = !state.isExperimental;
      localStorage.setItem('experimental-ux', next ? 'on' : 'off');
      return { isExperimental: next };
    }),
}));
